import { render, staticRenderFns } from "./ZhiFa.vue?vue&type=template&id=66f23fc0&scoped=true&"
import script from "./ZhiFa.vue?vue&type=script&lang=js&"
export * from "./ZhiFa.vue?vue&type=script&lang=js&"
import style0 from "./ZhiFa.vue?vue&type=style&index=0&id=66f23fc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f23fc0",
  null
  
)

export default component.exports